import Vue from "vue";

export default {
    setQuotes(state, quotes) {
        state.quotes = quotes;
    },
    addQuote(state, quote) {
        state.quotes.unshift(quote);
    },
    updateQuote(state, quote) {
        const index = state.quotes.findIndex((q) => q.id === quote.id);
        if (index !== -1) {
            Vue.set(state.quotes, index, { ...state.quotes[index], ...quote });
        }
    },
    deleteQuote(state, id) {
        const index = state.quotes.findIndex((schedule) => schedule.id === id);
        if (index !== -1) {
            state.quotes.splice(index, 1);
        }
    },
};
